import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import { ClientModeNotice } from '@/modules/nav-bar/client-mode-notice';
import { NavBar } from '@/modules/nav-bar/nav-bar';
import { useAuthStore } from '@/shared/auth/store';

export const Route = createFileRoute('/_auth')({
  beforeLoad: ({ context, location }) => {
    if (!context.auth.isAuthenticated) {
      throw redirect({
        to: '/login',
        search: { redirect: location.href },
      });
    }
  },
  component: AuthLayout,
});

function AuthLayout() {
  // Everything below the nav bar is distributor scoped: filter manifests,
  // option lists, report rows. Keying the outlet on the session's distributor
  // gives a switch the same clean slate the v1 portal got from a full page
  // reload, while keeping the nav bar (and its picker) mounted.
  const sessionKey = useAuthStore(
    (s) => `${s.user?.distrId ?? 0}:${s.user?.clientId ?? 0}`
  );

  return (
    <div className="flex min-h-screen flex-col">
      <NavBar />
      <main className="flex-1 px-4 py-4 sm:px-6">
        <ClientModeNotice />
        <Outlet key={sessionKey} />
      </main>
    </div>
  );
}
